import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useLocalStorage } from 'react-use'

import SEO from 'components/SEO'
import Layout from 'components/Layout'
import Heading from 'components/Heading'
import LinkButton from 'components/LinkButton'
import { THEME_RED } from 'theme/constants'
import { HOME_ROUTE } from 'routes/constants'

const NotFoundPage = ({ location }) => {
  const [isIntroFinished, setIntroFinished] = useState(false)
  const [hasIntroPlayed, setHasIntroPlayed] = useLocalStorage(
    'hasIntroPlayed',
    false,
  )
  function onIntroFinished(finished) {
    setIntroFinished(finished)
    setHasIntroPlayed(true)
  }

  return (
    <Layout
      isIntroFinished={isIntroFinished}
      onIntroFinished={onIntroFinished}
      hasIntroPlayed={hasIntroPlayed}
      theme={THEME_RED}
      location={location}
    >
      <SEO
        title="404 | Studio"
        description="We help the world’s top companies design, build, and ship amazing products and services."
      >
        <link rel="canonical" href="https://buildwithstudio.com/404/" />
      </SEO>
      <div
        className={cx('landing-page__container', 'is-404', {
          'is-active': isIntroFinished,
        })}
      >
        <Heading text="Page not found" />
        <div className="landing-page__action row margin-top --small">
          <LinkButton text="Take me home" route={HOME_ROUTE} />
        </div>
      </div>
    </Layout>
  )
}

NotFoundPage.propTypes = {
  location: PropTypes.object,
}

export default NotFoundPage
